import { useState } from "react";
import PhotoUploader from "./PhotoUploader";
import RichTextEditor from "./RichTextEditor";
import RelationSelector from "./RelationSelector";
import draftToHtml from "draftjs-to-html";
import { convertToRaw } from "draft-js";
import PageNumberInput from "./PageNumberInput";
import formatCurrency from "../../../utils/formatCurrency";

export default function ProductForm({
    onSubmit,
    initialForm = {
        name: "",
        description: "",
        category_id: "",
        category_price: 0,
        subcategory_id: "",
        subcategory_price: 0,
        weight: "",
        rating: "",
        status: "draft",
    },
    initialPhotos = [],
    initialEditorState,
    initialRelations = {
        sizes: [],
        cover_fabrics: [],
        cover_designs: [],
        page_numbers: [],
    },
    relationsOptions = {
        categories: [],
        subcategories: [],
        sizes: [],
        fabrics: [],
        designs: [],
        pages: [],
    },
}) {
    const [form, setForm] = useState(initialForm);
    const [photos, setPhotos] = useState(initialPhotos);
    const [editorState, setEditorState] = useState(initialEditorState);
    const [selectedOptions, setSelectedOptions] = useState(initialRelations);

    const handleFormChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const featureHTML = draftToHtml(convertToRaw(editorState.getCurrentContent()));

        const formData = new FormData();
        Object.entries(form).forEach(([key, val]) =>{
            if (key.includes("price")) {
                var cleaned = String(val).replace(/\./g, ""); // hapus titik ribuan
                if (cleaned === 'null' || cleaned === null || cleaned === undefined || cleaned === "") {
                    cleaned = "0";
                }
                formData.append(key, parseInt(cleaned, 10));
                console.log(key + ' ' + parseInt(cleaned, 10));
            } else {
                formData.append(key, val);
            }
        } )
        // formData.append(key, val));
        formData.append("feature_and_design", featureHTML);

        // Tambah relasi
        ["sizes", "cover_fabrics", "cover_designs", "page_numbers"].forEach((key) => {
            const arr = selectedOptions[key].map(item => ({
                ...item,
                price: item.price !== undefined && item.price !== null && item.price !== 'null' && item.price !== "" 
                    ? parseInt(String(item.price).replace(/\./g, ""), 10) 
                    : 0
            }));
            formData.append(key, JSON.stringify(arr));
            console.log(key + ' || ' + JSON.stringify(arr));
        });

        // Upload foto
        photos.forEach((p) => {
            if (p.file) formData.append("photos[]", p.file);
        });
        
        onSubmit(formData);
    };

    return (
        <form onSubmit={handleSubmit}>
            <h2>Form Produk</h2>

            <div className="row gy-4">
                <div className="col-sm-12 col-xs-12">
                    <label className="form-label mb-8 h6">Nama Produk:</label>
                    <input className="form-control py-11" placeholder="Nama Produk" name="name" value={form.name} onChange={handleFormChange} required />
                </div>
                <div className="col-sm-12 col-xs-12">
                    <label className="form-label mb-8 h6">Deskripsi Produk:</label>
                    <textarea className="form-control py-11" placeholder="Deskripsi Produk" rows={5} name="description" value={form.description} onChange={handleFormChange} />
                </div>

                <div className="col-sm-12 col-xs-12">
                    <hr />
                    <div className="row gy-4">
                        <div className="col-sm-6 col-xs-6">
                            <label className="form-label mb-8 h6">Kategori Produk:</label>
                            <select className="form-control py-11" name="category_id" value={form.category_id} onChange={handleFormChange} required>
                                <option value="">-- Pilih --</option>
                                {relationsOptions.categories.map((c) => (
                                    <option key={c.id} value={c.id}>{c.name}</option>
                                ))}
                            </select>
                        </div>

                        <div className="col-sm-6 col-xs-6">
                            <label className="form-label mb-8 h6">Harga Kategori Produk:</label>
                            <input
                                className="form-control py-11"
                                type="text"
                                // step="0.01"
                                name="category_price"
                                placeholder="Harga tambahan kategori"
                                value={formatCurrency(form.category_price)}
                                onChange={handleFormChange}
                            />
                        </div>
                    </div>
                    <hr />
                </div>

                <div className="col-sm-12 col-xs-12">
                    <hr />
                    <div className="row gy-4">
                        <div className="col-sm-6 col-xs-6">
                            <label className="form-label mb-8 h6">Subategori Produk:</label>
                            <select className="form-control py-11" name="subcategory_id" value={form.subcategory_id} onChange={handleFormChange}>
                                <option value="">-- Pilih --</option>
                                {relationsOptions.subcategories.map((s) => (
                                    <option key={s.id} value={s.id}>{s.name}</option>
                                ))}
                            </select>
                        </div>

                        <div className="col-sm-6 col-xs-6">
                            <label className="form-label mb-8 h6">Harga SubKategori Produk:</label>
                            <input
                                className="form-control py-11"
                                type="text"
                                step="0.01"
                                name="subcategory_price"
                                placeholder="Harga tambahan subkategori"
                                value={formatCurrency(form.subcategory_price)}
                                onChange={handleFormChange}
                            />
                        </div>
                    </div>
                    <hr />
                </div>

                <div className="col-sm-4 col-xs-4">
                    <label className="form-label mb-8 h6">Berat (gram):</label>
                    <input className="form-control py-11" type="number" step="0.01" name="weight" value={form.weight} onChange={handleFormChange} />
                </div>

                <div className="col-sm-4 col-xs-4">
                    <label className="form-label mb-8 h6">Status:</label>
                    <select className="form-control py-11" name="status" value={form.status} onChange={handleFormChange}>
                        <option value="draft">Draft</option>
                        <option value="active">Aktif</option>
                        <option value="archived">Arsip</option>
                    </select>
                </div>

            </div>


            <PhotoUploader photos={photos} setPhotos={setPhotos} />
            <RichTextEditor editorState={editorState} setEditorState={setEditorState} />

            <RelationSelector
                label="Ukuran + Harga Tambahan"
                options={relationsOptions.sizes}
                selected={selectedOptions.sizes}
                setSelected={(v) => setSelectedOptions({ ...selectedOptions, sizes: v })}
            />

            <hr />

            <RelationSelector
                label="Cover Fabric + Harga Tambahan"
                options={relationsOptions.fabrics}
                selected={selectedOptions.cover_fabrics}
                setSelected={(v) => setSelectedOptions({ ...selectedOptions, cover_fabrics: v })}
            />

            <hr />

            <RelationSelector
                label="Cover Design + Harga Tambahan"
                options={relationsOptions.designs}
                selected={selectedOptions.cover_designs}
                setSelected={(v) => setSelectedOptions({ ...selectedOptions, cover_designs: v })}
            />

            <hr />

            {/* <RelationSelector
                label="Jumlah Halaman + Harga Tambahan"
                options={relationsOptions.pages}
                selected={selectedOptions.page_numbers}
                setSelected={(v) => setSelectedOptions({ ...selectedOptions, page_numbers: v })}
            /> */}

            <PageNumberInput
                value={selectedOptions.page_numbers}
                setValue={(v) => setSelectedOptions({ ...selectedOptions, page_numbers: v })}
            />

            <br />
            <button className="btn btn-main" type="submit">Simpan Produk</button>
        </form>
    );
}
